module.exports = __webpack_public_path__ + "img/text+minipro.a79407bc.png";